import { createFileRoute, redirect } from '@tanstack/react-router';

// The consolidated page is served at /performance-beta; keep old links
// working. The hash carries the active tab (#campaigns), so it must survive
// the redirect — dropping it bounced every deep link to the default tab.
export const Route = createFileRoute('/_authenticated/_layout/performance-consolidated/')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/performance-beta', hash: location.hash || undefined });
  },
});
